import type { ComponentProps } from 'react';
import { PageFrame } from '@/shared/components/ui/PageFrame';

export type StackFrameProps = Omit<ComponentProps<typeof PageFrame>, 'topInset' | 'bottomInset'>;

export function StackFrame(props: StackFrameProps) {
  return <PageFrame topInset="stack" bottomInset="none" {...props} />;
}
